//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeature.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CamDirection",1,"Direction",0],[1,"DieTip",0,"Features.SelectFeature",0],[0,"FinishOperation",1,0],[0,"PointInRegion",1,"Point",0],[1,"RegionBounds",0,"ScCollector",0],[1,"ShapeDetail",0,"SelectDisplayableObjectList",0]],[[["nDetails"],"GetDetails",{R_:{details:""}},0,0],[["details"],"SetDetails",{},1,0]],[]];
SPLM.Tooling.DieEngFormTaskBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieEngFormTaskBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;